module.exports = __webpack_public_path__ + "img/avatarka-1.f688eefb.png";